import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayouts from "../layouts/MainLayouts";
import { useTranslation } from "react-i18next";
import CourseContentSection from "../components/courses/CourseContentSection";
import SimilarItemsSection from "../components/shared/SimilarItemsSection";
import CourseCard from "../components/CourseCard";
import { ICourseFlat } from "../domain/models/Course";
import { courseServiceFactory } from "../services/CourseServiceImpl";
import { useQuery } from "@tanstack/react-query";
import LoadingPanel from "../custom-components/CustomLoader";
import Button from "../components/ui/Button";
import { ButtonVariant } from "../types/constants";

const courseService = courseServiceFactory();

export default function CourseDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const {
        data: course,
        isLoading,
        isError,
    } = useQuery({
        queryKey: ["course", id, i18n.language],
        queryFn: async () => await courseService.getCourseById(id!),
        enabled: !!id,
    });

    if (isLoading) {
        return <LoadingPanel isVisible={isLoading} />;
    }

    if (isError || !course) {
        return (
            <MainLayouts pageTitle="">
                <div className="text-center py-20 text-5xl lg:max-w-[1280px] container flex flex-col justify-center items-center gap-12">
                    <h1>{t("courses.notFound")}</h1>
                    <Button onClick={() => navigate(-1)} text={t("common.back")} variant={ButtonVariant.BACK} />
                </div>
            </MainLayouts>
        );
    }

    return (
        <MainLayouts pageTitle={course.title}>
            <CourseContentSection course={course} />
            <SimilarItemsSection<ICourseFlat>
                currentItemId={id!}
                fetchItems={(page, limit) => courseService.getAllCourses(page, limit)}
                renderCard={(item) => <CourseCard course={item} showDetails={true} fullWidth={true} />}
                translationKey="courses.similarSection.title"
                queryKeyBase="courses"
            />
        </MainLayouts>
    );
}
